import { z } from 'zod';
import { SEOSchema } from '../shared/SEO';
import { EntityType } from '$lib/sanity/types';
import { GridLayoutSchema } from '../shared';
import { SanityDocumentSchema, SanitySlugSchema } from '../sanity';

export const LegalPageSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.LegalPage),
  slug: SanitySlugSchema,
  header: z
    .object({
      title: z.string()
    })
    .nullish(),
  seoAttributes: SEOSchema.nullish(),
  layout: GridLayoutSchema.nullish()
});

export type LegalPage = z.infer<typeof LegalPageSchema>;
